import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import api from '@/utils/api';

interface SystemNotification {
  id: string;
  message: string;
  type: 'info' | 'warning' | 'error' | 'success';
}

const STORAGE_KEY = 'klyx_dismissed_notification';

export function useSystemNotification() {
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    api.get<{ notification: SystemNotification | null }>('/system-notification')
      .then(({ data }) => {
        const n = data.notification;
        if (!n) return;

        // Don't re-show if user already dismissed this exact notification
        const dismissed = localStorage.getItem(STORAGE_KEY);
        if (dismissed === n.id) return;

        toast[n.type](n.message, {
          toastId: `system-${n.id}`,
          autoClose: false,
          closeOnClick: false,
          onClose: () => localStorage.setItem(STORAGE_KEY, n.id),
          style: { maxWidth: '600px' },
        });
      })
      .catch(() => {}); // Silently ignore — non-critical
  }, []);
}
